import makeStyles from "@mui/styles/makeStyles";
import { LegendItemProps } from "./LegendItem.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: LegendItemProps) => ({
    position: "relative",
    marginLeft: 16,
    "&:first-child": {
      marginLeft: 0,
    },
    "&::before": {
      content: "''",
      display: "inline-block",
      width: 12,
      height: 12,
      marginRight: 12,
      borderRadius: 999,
      background: props.color,
    },
    [theme.breakpoints.up("lg")]: {
      marginLeft: 40,
    },
  }),
}));
